import Box from "@mui/material/Box"
import dynamic from "next/dynamic"
import useCartHandler from '@components/_hooks/Cart/useCartHandler'
import useCartActions from '@components/_hooks/Cart/useCartActions'
import useWindowSize from "@components/_hooks/useWindowSize"
import { count, isDefined } from "@components/config/helpers"
import ProductPackageCore from "./ProductPackageCore"
import Grid from "@mui/material/GridLegacy"
import Button from "@mui/material/Button"
import ProductCarouselContainer from "../ProductCarouselContainer"
import { useState } from "react"
import PackageCoreColours from "./PackageCoreColours"
import P from "@components/Components/Reusables/Typography/P"
import { useSelector } from "react-redux"
import useGlobalSettings from "@components/_hooks/useGlobalSettings"
import ToggleButton from "@mui/material/ToggleButton"
import useExtraDialog from "@components/_hooks/Cart/useExtraDialog"

const ProductExtras = dynamic(() => import('./ProductExtras'))
const ProductExtrasDialog = dynamic(() => import('../ProductExtrasDialog'), { ssr: false })
const ProductCardHeader = dynamic(() => import('./ProductCardHeader'))
const ProductCardKeyFeatures = dynamic(() => import('./ProductCardKeyFeatures'))
const ProductPrimaryDescription = dynamic(() => import('./ProductPrimaryDescription'))
const ProductAddToCart = dynamic(() => import('./ProductAddToCart'))
const ProductHeading = dynamic(() => import('../ProductHeading'))
const ProductAccordions = dynamic(() => import('../ProductAccordions'))
const ProductVariants = dynamic(() => import('../ProductCard/Variants/ProductVariants'))
const ProductCardAddonGroups = dynamic(() => import('./ProductCardAddonGroups'))
const ProductMeasurements = dynamic(() => import('../ProductTabs/TabKeys/ProductMeasurements'))

const ProductCard = (props) => {
    const {
        extras,
        product,
        long_term_product,
        price_breaks,
        new_price_breaks,
        productData,
        product_variants,
        diameter,
        width,
        depth,
        height,
        source,
        activeTab,
        measurements,
        key_features,
        videos,
        faqs,
        articles,
        long_desc,
        reviews,
        addon_groups,
        template_page_settings,
        related_products,
        long_term,
        set_extra_image_set,
        set_thumbnail_images,
        finishes,
        product_finishes,
        product_extras,
        setActiveTabValue,
        setPromotionAvailable,
        promotionAvailable
    } = props;

    const key_features_md_column = template_page_settings?.key_features_md_column == null ? 6 : Number(template_page_settings.key_features_md_column);

    const {
        addToCart,
        bulkAddToCart: cardHandlerBulkAdd
    } = useCartHandler();

    const {
        handleQtyChange,
        qty,
        setQty,
    } = useCartActions();

    const { isMobile, width: windowWidth } = useWindowSize();
    const { getSetting } = useGlobalSettings()
    const [loading, setLoading] = useState(false);

    const [masterPackage, setMasterPackage] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [selectedPackageData, setSelectedPackageData] = useState([]);
    const [selectedColour, setSelectedColour] = useState({
        label: 'White',
        slug: 'package-core-white',
        qty: 1
    });

    const [bulkAddQty, setBulkAddQty] = useState([]);

    const cartUpdating = useSelector((state) => state.cartManagementReducer.cartUpdating);

    const handleBulkAdd = (e, type, product) => {
        if (!product || !product.product_code || !product.product_id) {
            console.error("Invalid data");
            return;
        }

        const { product_code, product_id, product_slug } = product;
        let newArray = [...bulkAddQty];
        const foundIndex = newArray.findIndex(item => item.product_id === product_id);
        const element = document.querySelector(`#product-${product.product_id}`)
        let qty = Number(element.value);

        if (type == 'subtract') {
            if (qty > 0) {
                qty -= Number(1)
            }
        }
        else {
            qty += 1;
        }

        if (foundIndex === -1 && qty !== 0) {
            newArray.push({
                qty: 1,
                product_code,
                product_id,
                slug: product_slug
            });
        } else {
            newArray[foundIndex] = {
                ...newArray[foundIndex],
                qty
            };
        }

        // removes the object with qty = 0 from the array.
        newArray = newArray.map(item => {    // It uses map() to replace the matching object with null, 
            return item.qty !== 0 ? item : null;
        }).filter(item => item !== null);    // then filters out null values using filter(), leaving the remaining objects in the array.

        setBulkAddQty(newArray);

        element.value = qty;

    };


    const bulkAddToCart = () => {
        setLoading(true);
        const bulkProducts = [];

        let mainStr = {

        }

        // Set the initial product in the cart
        bulkProducts.push({
            qty: 1,
            slug: selectedPackageData.product_slug,
            name: selectedPackageData.product_name
        })

        // 4 | 1 | 1
        //  = 3 straights
        // Go through each product in the options and add them to the cart. Check for existing products and just increase the qty.
        let colourQty = 0;
        masterPackage.forEach((product, idx) => {
            const search = bulkProducts.findIndex((master_product) => master_product.slug == product.slug);
            if (search != -1) {
                bulkProducts[search].qty = parseInt(bulkProducts[search].qty) + parseInt(product.qty);
                let newColQty = product?.finish_multiplier != null ? parseInt(product.qty) * parseFloat(product.finish_multiplier) : parseInt(product.qty);
                colourQty = parseInt(colourQty) + parseInt(newColQty)
                const qty = (parseInt(product.qty));
                if (!mainStr?.[product.name]) {
                    mainStr = {
                        ...mainStr,
                        [product.name]: {
                            qty: qty
                        }
                    }
                }
            }
            else {
                bulkProducts.push({
                    qty: product.qty,
                    slug: product.slug,
                    name: product.name
                })
                let newColQty = product?.finish_multiplier != null ? parseInt(product.qty) * parseFloat(product.finish_multiplier) : parseInt(product.qty);
                colourQty = (parseInt(colourQty) + parseInt(newColQty));
                console.log({
                    mult: product.finish_multiplier,
                    colQqty: newColQty,
                    colourQty
                })

                mainStr = {
                    ...mainStr,
                    [product.name]: {
                        qty: (parseInt(product.qty))
                    }
                }
            }

            if (idx == masterPackage.length - 1) {
                // let latestIdx = search != -1 ? search : bulkProducts.length - 1;
                if (product?.multiplier && product.multiplier > 0) {
                    // const bulkProduct = bulkProducts[latestIdx];
                    // console.log(bulkProduct.qty)
                    // bulkProducts[latestIdx].qty = parseInt(bulkProducts[latestIdx].qty) + parseFloat(product.multiplier);
                    let appendedString = ` (`;
                    Object.keys(mainStr).map((key, idx) => {
                        appendedString += `${mainStr[key].qty} ${key}`
                        if (idx != Object.keys(mainStr).length - 1) {
                            appendedString += ', ';
                        }
                    })
                    appendedString += ')';
                    bulkProducts[0].overridden_str = appendedString;
                }
            }

        })
        // Go through the additional/frequently hired with products and push them to the cart
        bulkAddQty.forEach(product => bulkProducts.push({
            qty: product.qty,
            slug: product.slug,
            name: product.name
        }))

        // Add the selected finish to the cart
        if (selectedColour.label != 'White') {
            bulkProducts.push({
                // qty: selectedColour.qty,
                qty: colourQty,
                slug: selectedColour.slug,
                name: selectedColour.label
            });
        }

        // Move the colours to the second index
        const colourObject = bulkProducts.pop();
        bulkProducts.splice(1, 0, colourObject);

        cardHandlerBulkAdd(bulkProducts);

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }

    const AddToCartButton = () => (
        <ProductAddToCart
            cartControls={{
                addToCart,
                handleQtyChange,
                qty,
                setQty,
            }}
            product={product}
            source={source}
            props={productData}
        />
    )


    const md_grid = product?.package_core_group_id == null ? 6 : 12
    const { open, handleToggle, extraProductData, setExtraProductData } = useExtraDialog();

    return (
        <>
            <Grid item xs={12} md={md_grid} lg={6}>

                {open && extraProductData?.product?.product_id && (
                    <ProductExtrasDialog extrasData={extraProductData} open={open} toggle={handleToggle} />
                )}


                <Box className={``}>
                    {!isMobile &&
                        <ProductHeading
                            product={product}
                            product_rating={product.product_rating}
                            product_rating_count={product.product_rating_count}
                            template_page_settings={template_page_settings}
                            setActiveTabValue={setActiveTabValue}
                            setPromotionAvailable={setPromotionAvailable}
                        />

                    }

                    {
                        <>
                            <ProductCardHeader
                                diameter={diameter}
                                width={width}
                                depth={depth}
                                height={height}
                                weight={product?.weight}
                            />
                        </>
                    }

                    {isDefined(addon_groups) && count(addon_groups) > 0 && (
                        <Box
                            className='w-100'
                        >
                            <ProductCardAddonGroups addon_groups={addon_groups} />
                        </Box>
                    )}

                    {product_extras && Object.keys(product_extras)?.length > 0 && (
                        <div className="mt-2">
                            <ProductExtras
                                is_dialog={false}
                                product_image={product.image}
                                primary_product_id={product.product_id}
                                product_extras={product_extras}
                                is_mandatory={product.is_mandatory || 'yes'}
                                callbacks={{
                                    set_extra_image_set,
                                    set_thumbnail_images,
                                }}
                            />
                        </div>
                    )}

                    {
                        product?.package_core_group_id == null && (
                            <ProductAddToCart
                                cartControls={{
                                    addToCart,
                                    handleQtyChange,
                                    qty,
                                    setQty,
                                }}
                                product={product}
                                source={source}
                                props={productData}
                            />
                        )
                    }
                    {isDefined(product_variants) && count(product_variants) > 1 && !isMobile && <ProductVariants product_id={product.product_id} product_variants={product_variants} />}


                    {/* <ProductPrimaryDescription
                        product={product}
                        template_page_settings={{
                            show_description_short: template_page_settings?.show_description_short || null
                        }}
                    /> */}
                    <ProductCardKeyFeatures
                        promotion_available={promotionAvailable}
                        product={product}
                        long_term_product={long_term_product}
                        key_features={product.ext_attributes.key_feature}
                        price_breaks={price_breaks}
                        new_price_breaks={new_price_breaks}
                        ecoLeaf={(getSetting('carbon_footprint', 'no') == 'yes') && product?.carbon ? true : false}
                        key_features_md_column={key_features_md_column}
                        product_variants={product_variants}
                    />
                    {/* {
                (product?.package_core_group_id == null && !isMobile || windowWidth > 900) && (
                    <AddToCartButton/>
                )
            } */}

                    {isDefined(product_variants) && count(product_variants) > 1 && isMobile && <ProductVariants product_id={product.product_id} product_variants={product_variants} />}

                    {/* <ParseHtml html={product.product_description_short}/> */}

                    {isMobile && activeTab != null && (
                        <ProductAccordions
                            measurements={measurements}
                            key_features={key_features}
                            videos={videos}
                            articles={articles}
                            reviews={reviews}
                            faqs={faqs}
                            product={product}
                            long_term_product={long_term_product}
                            long_desc={long_desc}
                            width={width}
                            depth={depth}
                            height={height}
                        />
                    )}


                    {product?.package_core_group_id != null && (
                        <>
                            <ProductPackageCore
                                product={product}
                                selectedPackage={selectedPackage}
                                setSelectedPackage={setSelectedPackage}
                                setSelectedPackageData={setSelectedPackageData}
                                setMasterPackage={setMasterPackage}
                                set_extra_image_set={set_extra_image_set}
                                set_thumbnail_images={set_thumbnail_images}
                            />
                        </>
                    )}
                </Box>
            </Grid>

            {product?.package_core_group_id != null && (
                <div>
                    <PackageCoreColours
                        product_finishes={product_finishes}
                        finishes={finishes}
                        selectedColour={selectedColour}
                        setSelectedColour={setSelectedColour}
                    />
                </div>
            )}

            {/* {(measurements && count(Object.keys(measurements)) > 0) || (width || depth || height) && (
                <>
                    <ToggleButton
                        value={'measurements'}
                        sx={{
                            border: '1px solid var(--color-primary)',
                            backgroundColor: 'primary.main',
                            color: 'primary.contrastText',
                            ':hover': {
                                backgroundColor: 'primary.main',
                                color: 'primary.contrastText',
                            },
                        }}>{"Measurements & Spec"}</ToggleButton>
                    <Box className={`measurements w-100 p-2`}>
                        <ProductMeasurements
                            width={width}
                            depth={depth}
                            height={height}
                            measurements={measurements}
                            product={product}
                        />
                    </Box>
                </>
            )} */}

            {count(related_products) > 0 && (
                <Grid item xs={12} className='w-100 pt-0'>
                    <ProductCarouselContainer
                        title={product?.package_core_group_id != null ? "Add Accessories" : "Frequently Hired With..."}
                        color={product?.package_core_group_id != null ? 'secondary' : 'primary'}
                        className=""
                        package_core={product?.package_core_group_id}
                        productData={productData}
                        products={related_products}
                        long_term={long_term}
                        show_add_button={false}
                        addToQuoteComponent={product?.package_core_group_id == null ? false : handleBulkAdd}
                        extrasHook={{
                            open,
                            handleToggle,
                            extraProductData,
                            setExtraProductData
                        }}
                    />
                </Grid>
            )}


            {product?.package_core_group_id != null && (
                <div className="ml-2 mb-4">
                    <br />
                    <P className="fs-14">Please call if you need alcohol delivered with this bar</P>
                    <Button loading={loading || cartUpdating} size="small" variant="contained" color="secondary" onClick={bulkAddToCart}>
                        ADD TO QUOTE
                    </Button>
                </div>
            )}

        </>
    )
}

export default ProductCard